module.exports = __webpack_public_path__ + "static/media/bg1.cd0c615e.png";